import { AppState } from "../../../redux-configuration/AppState";
import { SocialPageInfo } from "../../domain/entity/socialPageInfo";

export const findFacebookPagesLoadingSelector = (appState: AppState): boolean => appState.company.findFacebookPage.loading
export const findFacebookPagesErrorSelector = (appState: AppState): string | undefined => appState.company.findFacebookPage.error
export const facebookPagesSelector = (appState: AppState): SocialPageInfo[] | null => appState.company.findFacebookPage.pageInfo
